__turbopack_context__.v({
  "definitionList": "styles-module-scss-module__Q05tRG__definitionList",
  "erom-definition-list-item": "styles-module-scss-module__Q05tRG__erom-definition-list-item",
});
